export default __webpack_public_path__ + "static/media/life-insurance-lic--250x250.b41c9eb5.svg";